import React from "react";
import { Modal, Grid } from "@mui/material";
import useStyles from "./styles";
import classnames from "classnames";
import { BsInfoCircle } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import ActionButtons from "../../../../../../../../../components/Generic/ActionButtons";
import { IoMdClose } from "react-icons/io";

interface ConfirmationUploadPricesProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}
export const ConfirmationUploadPrices: React.FC<ConfirmationUploadPricesProps> = (props) => {
  const { opened, onClose, onConfirm, onCancel } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Modal open={opened} onClose={onClose}>
      <div className={classes.container}>
        <section className={classes.header}>
          <Grid container direction="row" alignItems="center">
            <Grid item className={classes.badge}>
              <BsInfoCircle color="#308CDB" size={22} />
            </Grid>
            <Grid item className={classes.title}>
              <span>{t("updatePrices")}</span>
            </Grid>
          </Grid>
          <Grid item onClick={onClose}>
            <IoMdClose className={classes.button} color="#232325" size={22} />
          </Grid>
        </section>

        <section className={classes.content}>
          <Grid container direction="column"></Grid>
          <Grid item className={classes.description}>
            <span>{t("weWillUpdateAllPricesDisregardingThoseMarkedWith")}</span>
          </Grid>
          <Grid item className={classes.rememberMessage}>
            <span>{t("ifYouWantToUpdateThesePricesYouShouldEditFile")}</span>
          </Grid>
        </section>

        <section className={classes.footer}>
          <ActionButtons textSave={t("confirm")} onSave={onConfirm} onCancel={onCancel} />
        </section>
      </div>
    </Modal>
  );
};
